"use strict";
/*
 * Copyright (c) "Neo4j"
 * Neo4j Sweden AB [http://neo4j.com]
 *
 * This file is part of Neo4j.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAutogeneratedFields = getAutogeneratedFields;
const IdField_1 = require("../../ast/input-fields/IdField");
const TimestampField_1 = require("../../ast/input-fields/TimestampField");
const is_concrete_entity_1 = require("../../utils/is-concrete-entity");
function getAutogeneratedFields(target) {
    const attachedTo = (0, is_concrete_entity_1.isConcreteEntity)(target) ? "node" : "relationship";
    const autoGeneratedFields = [];
    for (const attribute of target.attributes.values()) {
        if (attribute.timestampCreateIsGenerated()) {
            autoGeneratedFields.push(new TimestampField_1.TimestampField(attribute.name, attribute, attachedTo));
        }
        if (attribute.annotations.id) {
            autoGeneratedFields.push(new IdField_1.IdField(attribute.name, attribute, attachedTo));
        }
    }
    return autoGeneratedFields;
}
//# sourceMappingURL=get-autogenerated-fields.js.map